var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Inode',_vm._b({},'Inode',_vm.settings,false))
}
var staticRenderFns = []

export { render, staticRenderFns }